export const config = {
  title: "The Best Cleaning Pro",
  meta: {
    description:
      "The Best Cleaning Pro offers top-tier residential and commercial cleaning services across Southern California. Experience excellence in cleanliness with our professional team.",
    keywords: [
      "Professional Cleaning Services",
      "Residential Cleaning",
      "Commercial Cleaning",
      "Deep Cleaning",
      "Southern California Cleaning Services",
    ],
    author: "The Best Cleaning Pro",
    canonicalUrl: "https://www.thebestcleaningpro.com/",
  },
  sections: {
    header: {
      businessName: "The Best Cleaning Pro",
    },
    sectionB: {
      heroTitle: "Your Trusted Cleaning Partner",
      heroSubtitle: "Professional Cleaning Services for Homes and Businesses",
      learnAboutText: "Discover Our Services",
      phoneNumber: "9498134773",
      phoneLabel: "(949) 813-4773",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1417833187/photo/professional-cleaner-vacuuming-a-carpet.jpg?s=612x612&w=0&k=20&c=5h8NBR190d46Ni4MclqJ7Zf9ZOtf3TM3gPRJaHUdMjk=",
      cardData: [
        {
          title: "Residential Cleaning",
          description:
            "Keep your home spotless with our comprehensive residential cleaning services.",
        },
        {
          title: "Commercial Cleaning",
          description:
            "Maintain a professional environment with our reliable commercial cleaning solutions.",
        },
        {
          title: "Deep Cleaning",
          description:
            "Thorough cleaning services to ensure every corner of your space shines.",
        },
      ],
      description:
        "At The Best Cleaning Pro, we are committed to delivering exceptional cleaning services tailored to your needs. Whether it's your home or business, our team ensures a pristine environment every time.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Comprehensive cleaning solutions designed to meet your unique requirements.",
      cards: [
        {
          title: "Detailed Cleaning",
          description:
            "Regular cleaning services to keep your space consistently clean.",
          imageSrc:
            "https://media.istockphoto.com/id/1316800918/photo/shot-of-an-unrecognizable-woman-holding-a-bucket-of-cleaning-detergent-before-mopping-her.jpg?s=612x612&w=0&k=20&c=TCeNpLYcetLLv9_oyalz7d4-mGnKkw5si64P54NdC3U=",
          imageAlt: "Standard Cleaning",
        },
        {
          title: "Hauling Services",
          description:
            "Ensure a fresh start with our detailed move-in and move-out cleaning services.",
          imageSrc:
            "https://media.istockphoto.com/id/1333290576/photo/cardboard-boxes-and-sofa-for-moving-into-a-new-home-apartment-indoor-lifestyle.jpg?s=612x612&w=0&k=20&c=pg78AWkksi7uqx7slS-1Bll_y1LnnkPJjZWOypFj66c=",
          imageAlt: "Move-In/Move-Out Cleaning",
        },
        {
          title: "Commercial Cleaning",
          description:
            " Our commercial cleaning service ensures that your business environment remains pristine, creating a welcoming atmosphere for clients and employees alike.",
          imageSrc:
            "https://media.istockphoto.com/id/2162227486/photo/construction-worker-vacuuming-concrete-floor-before-applying-epoxy.jpg?s=612x612&w=0&k=20&c=6ymrSpLgm07VPBNvl2gUd4bvg7Mx6b7UsWjQ--_XHtE=",
          imageAlt: "Post-Construction Cleaning",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Window Cleaning",
        "Carpet Cleaning",
        "Upholstery Cleaning",
        "Green Cleaning",
        "Customized Cleaning Plans",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://media.istockphoto.com/id/1042399650/photo/detergents-and-cleaning-accessories-in-pastel-color-cleaning-service-small-business-idea-top.jpg?s=612x612&w=0&k=20&c=S79iwA7M8CxX3YNNN-19ORWz8JHeiyudL_Q76_ZHqnY=",
        alt: "The Best Cleaning Pro Team",
      },
      aboutText: [
        "With years of experience in the cleaning industry, The Best Cleaning Pro is dedicated to providing top-quality cleaning services across Southern California.",
        "Our team of professionals is trained to handle all cleaning tasks efficiently, ensuring customer satisfaction every step of the way.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "The Best Cleaning Pro Logo",
      businessName: "The Best Cleaning Pro",
      contact: {
        phone: "9498134773",
        phoneLabel: "(949) 813-4773",
        email: "shalom35@hotmail.com",
        website: "https://www.thebestcleaningpro.com/",
        address: "Lake Forest, CA",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "Lake Forest, CA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3311.123456789!2d-117.6892345!3d33.6462106!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dc123456789abc%3A0xabcdef1234567890!2sLake%20Forest%2C%20CA!5e0!3m2!1sen!2sus!4v1614123456789!5m2!1sen!2sus",
    },
  },
};

export default config;
